module.exports = __webpack_public_path__ + "img/icon-bathroom.a97b637c.svg";